<template>
  <v-app-bar
    app
    color="#24344B"
    dark
    height="48"
    elevation="0"
    class="app-bar"
    style="z-index:25"
  >
    <v-toolbar-title v-if="constructionName">{{
      constructionName
    }}</v-toolbar-title>
    <v-spacer v-if="windowWidth <= 500" />
    <img
      src="/static/topper/메뉴.svg"
      width="32"
      height="48"
      @click="$bus.$emit('mobileDrawer')"
      class="cursor-pointer"
      v-if="windowWidth <= 500"
    />
  </v-app-bar>
</template>

<script>
import Mobile from "../mixin/Mobile";
export default {
  mixins: [Mobile],
  computed: {
    constructionName() {
      return this.$store.state.Const.constructionId
        ? this.$store.state.Const.constructionId.constructionName
        : "";
    },
  },
};
</script>
